module.exports = "\n\n::ng-deep .read-more[data-v-6ad3d82e]\n{\n    display: none;\n}"